import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Tooltip } from 'antd';
import history from '../../../core/utils/history';
import GridView from '../../../components/elements/GridView/index';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import { UserRole } from '../../../types/types';

export default function () {
    const {
        actions,
        users,
        usersPagination,
    } = this.props;

    const userDisplayRole = (role) => {
        switch (role) {
            case UserRole.User:
                return 'User';
            case UserRole.Manager:
                return 'Manager';
            case UserRole.Admin:
                return 'Admin';
            case UserRole.SalesAdmin:
                return 'Sales Admin';
            case UserRole.SuperAdmin:
                return 'Super Admin';

            default:
                return role;
        }
    };

    const {
        searchParams,
        orderParams,
    } = this.state;

    let data = [];
    if (users) {
        data = users.map((d) => {
            const displayRole = userDisplayRole(d.role);

            const divisionsArray = d.divisions.split('$|$');
            const divisionsCount = divisionsArray.length;
            let divisionsList = `Divisions: ${divisionsCount}`;

            if (d.divisions === 'All' || d.divisions === 'None') {
                divisionsList = `Divisions: ${d.divisions}`;
            }

            // Render each division on its own line without using a string
            const divisionsTooltip = (
                <div>
                    {divisionsArray.map((division, idx) => (
                        <div key={idx}>- {division}</div>
                    ))}
                </div>
            );

            return ({
                id: d.user_id,
                email: d.email,
                role: displayRole,
                name: d.name,
                divisions: (
                    <Tooltip title={divisionsTooltip}>
                        {divisionsList}
                    </Tooltip>
                ),
                status: parseInt(d.status, 10) === 1 ? 'Active' : 'Inactive',
                actions: (
                    <>
                        <Link
                            to={`/users/view/${d.user_id}`}
                            className="btn-actions"
                        >
                            View
                        </Link>
                    </>
                ),
            });
        });
    }

    const paginationChange = (page) => {
        if (page !== usersPagination.currentPage) {
            actions.getUsersPageRequest({
                page,
                searchParams, ...orderParams,
            });
        }
    };

    const gridChange = (pagination, filters, sorter) => {
        if (pagination && pagination.current === parseInt(usersPagination.currentPage, 10)) {
            const params = { orderBy: `${sorter.order === 'descend' ? '-' : ''}${sorter.field}` };
            this.setState({ orderParams: params });
            actions.saveUserOrderParamsRequest(params);
            actions.getUsersPageRequest({
                page: usersPagination.currentPage,
                searchParams, ...params,
            });
        }
    };

    return (
        <>
            <div className="section__action-bar">
                <Button
                    type="primary"
                    onClick={() => history.push('/users/create')}
                    className="page-header-button"
                    style={{
                        top: '-28px',
                        right: '16px',
                    }}
                >
                    Add user
                </Button>
            </div>
            <div style={{
                marginTop: '-16px',
            }} />
            <div className="section__body">
                <GridView
                    data={data}
                    onChange={gridChange}
                    sortableColumns={['user_id', 'email', 'role', 'name', 'status']}
                    pagination={{
                        total: parseInt(usersPagination.totalRecords, 10),
                        showSizeChanger: false,
                        pageSize: usersPagination.perPage,
                        current: parseInt(usersPagination.currentPage, 10),
                        onChange: paginationChange,
                        showTotal: getPaginationTotal,
                    }}
                />
            </div>
        </>
    );
}
